import request from '@/utils/request'
//用户列表
export const getUserList = (data) => request.post(`/sysUser/page`,data)
//新增/编辑用户
export const addOrUpdate = (data) => request.post('/sysUser/addOrUpdate',data)
//重置密码
export const resetPassword = (data) => request.post(`/sysUser/reset`,data)
//删除
export const delUser = (id) => request.delete(`/sysUser/del/${id}`)
//修改密码
export const updatePwd = (data) => request.post(`/sysUser/change/password`,data)
//修改头像
export const updateHeadImg = (data) => request.post(`/sysUser/change/headImg`,data)
//获取当前登录信息
export const getLogoInfo = () => request.get(`/sysUser/getCurrentUserInfo`)
